export default __webpack_public_path__ + "static/media/Printed_Circuit_Board.76cfc491.jpg";